export default __webpack_public_path__ + "static/media/slider1-3.09a77bdd.jpg";